import axiosInstance from "@/utils/axios";
import guestAxios from "@/utils/guestAxios";

export const guestsApi = {
  getAll: (params = {}) => axiosInstance.get("/api/guests", { params }),
  getById: (guestId) => axiosInstance.get(`/api/guests/${guestId}`),
  create: (payload) => axiosInstance.post("/api/guests", payload),
  update: (guestId, payload) => axiosInstance.put(`/api/guests/${guestId}`, payload),
  delete: (guestId) => axiosInstance.delete(`/api/guests/${guestId}`),
  search: (query) => axiosInstance.get("/api/guests/search", { params: { query } }),
  getHistory: (guestId) => axiosInstance.get(`/api/guests/${guestId}/history`),
  getStays: (guestId) => axiosInstance.get(`/api/guests/${guestId}/stays`),
  getOrders: (guestId) => axiosInstance.get(`/api/guests/${guestId}/orders`),
  getBills: (guestId) => axiosInstance.get(`/api/guests/${guestId}/bills`),
  getRequests: (guestId) => axiosInstance.get(`/api/guests/${guestId}/requests`),
  getFeedback: (guestId) => axiosInstance.get(`/api/guests/${guestId}/feedback`),
  register: (payload) => axiosInstance.post("/api/guests/register", payload),
  registerFromGuestPortal: (payload) => guestAxios.post("/api/guests/register", payload),
  sendVerification: (guestId) => axiosInstance.post(`/api/guests/${guestId}/send-verification`),
  verifyEmail: (payload) => axiosInstance.post("/api/guests/verify-email", payload),
  linkInHimalayasUser: (guestId, payload) =>
    axiosInstance.post(`/api/guests/${guestId}/link-inhimalayas-user`, payload),
  convertAnonymous: (guestId, payload) =>
    axiosInstance.post(`/api/guests/${guestId}/convert-anonymous`, payload),
  merge: (guestId, payload) => axiosInstance.post(`/api/guests/${guestId}/merge`, payload),
  assignSession: (guestId, payload) => axiosInstance.post(`/api/guests/${guestId}/assign-session`, payload),
};
